import { createFileRoute } from '@tanstack/react-router';

import { RkTransactionsGrid } from '../../components';

const TransactionsPage = () => <RkTransactionsGrid mode='transactions' />;

export const Route = createFileRoute('/participant-transactions/')({
  component: TransactionsPage
});
